import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Side-effect import: registra campos custom do component-registry (ex: endereço do cliente).
import '@/pages/_app/customers/+components/address-fields';

const elem = document.getElementById('root')!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}
